import React, { createContext, useEffect, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { t } from 'ttag';

import { mergeClasses } from '@utils';

import './Breadcrumbs.css';

import BreadcrumbsBreadcrumb from './Breadcrumbs.Breadcrumb';

export const BreadcrumbsContext = createContext();

export default function Breadcrumbs({ children, className, ...restProps }) {
  if (!children) return null;

  /**
   * navRef Reference to be used to target the <nav> in the DOM.
   * @type {React.MutableRefObject<null>}
   */
  const navRef = useRef(null);

  useEffect(() => {
    if (navRef.current) navRef.current.scrollLeft = navRef.current.scrollWidth;
  }, [children]);

  const contextValue = useMemo(() => ({}), []);

  return (
    <BreadcrumbsContext.Provider value={contextValue}>
      <nav
        ref={navRef}
        className="hide-scrollbar flex min-h-[38px] items-center overflow-x-scroll scroll-smooth"
        aria-label={
          // translator: The aria-label for the Breadcrumbs component. This is used by screen readers to describe the component.
          t`Breadcrumbs`
        }
        style={{}}
      >
        <ul
          className={mergeClasses(
            'm-0 flex list-none space-x-1 p-0 text-sm font-semibold',
            className
          )}
          {...restProps}
        >
          {children}
        </ul>
      </nav>
    </BreadcrumbsContext.Provider>
  );
}

Breadcrumbs.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

Breadcrumbs.defaultProps = {
  className: ''
};

Breadcrumbs.Breadcrumb = BreadcrumbsBreadcrumb;
